import { apiGenericDelete, apiGenericGet, apiGenericPost } from '@service/genericAPICall';
import {
  AnnouncementAudioResponse,
  AnnouncementBriefDTO,
  AnnouncementContentRequest,
  AnnouncementDTO,
  AnnouncementGenerateMp3Request,
  AnnouncementImageContentRequest,
  AnnouncementItemContentRequest,
  AnnouncementItemDTO,
  AnnouncementLayoutPreviewRequest,
  AnnouncementLoadRequest,
  AnnouncementPreviewDTO,
  AnnouncementSearchRequest,
  AnnouncementTextContentRequest,
  LayoutStopDTO,
  RasterDTO,
  RealTimeAnnouncementPreviewDTO,
  TerminalPreviewDTO,
} from '@/model';
import { GenericDeleteResponse, GenericPostResponse } from '@/type';
import { getApiUrl } from '@/util';

const BASE_URL = '/api/v1/announcement/';

export const saveAnnouncementAPI = (
  request: AnnouncementDTO,
): Promise<GenericPostResponse<number>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'save'), request);

// Saves a single item (not the whole announcement) — the backend mirrors
// the render fields (backgroundColor/imageResizeType/anchorX/anchorY) onto
// the associated Element itself, so no separate element save is needed here.
export const saveAnnouncementItemAPI = (
  request: AnnouncementItemDTO,
): Promise<GenericPostResponse<number>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'save-item'), request);

export const deleteAnnouncementItemAPI = (id: number): Promise<GenericDeleteResponse> =>
  apiGenericDelete(getApiUrl(BASE_URL, 'delete-item'), 'id', id);

export const listAnnouncementAPI = (
  request: AnnouncementSearchRequest,
): Promise<GenericPostResponse<AnnouncementBriefDTO[]>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'list'), request, true);

export const loadAnnouncementAPI = (
  request: AnnouncementLoadRequest,
): Promise<GenericPostResponse<AnnouncementDTO>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'load'), request, true);

export const loadAnnouncementItemsAPI = (
  request: AnnouncementLoadRequest,
): Promise<GenericPostResponse<AnnouncementDTO>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'load'), request, true);

export const loadAnnouncementPreviewAPI = (
  request: AnnouncementContentRequest,
): Promise<GenericPostResponse<TerminalPreviewDTO[]>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'loadPreview'), request, true);

export const deleteAnnouncementAPI = (id: number): Promise<GenericDeleteResponse> =>
  apiGenericDelete(getApiUrl(BASE_URL, 'remove'), 'id', id);

export const listAnnouncementAssignedLayoutsByIdAPI = (
  id: number,
): Promise<LayoutStopDTO[]> =>
  apiGenericGet(getApiUrl(BASE_URL, `listLayoutsById/${id}`));

export const listAnnouncementForStopsAPI = (
  request: AnnouncementSearchRequest,
): Promise<GenericPostResponse<AnnouncementDTO[]>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'listForStops'), request, true);

export const loadLayoutPreviewAnnouncementAPI = (
  request: AnnouncementLayoutPreviewRequest,
): Promise<GenericPostResponse<AnnouncementPreviewDTO>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'loadLayoutPreview'), request, true);

export const loadAnnouncementTextPreviewAPI = (
  request: AnnouncementTextContentRequest,
): Promise<GenericPostResponse<AnnouncementPreviewDTO>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'loadTextPreview'), request, true);

export const loadAnnouncementImagePreviewAPI = (
  request: AnnouncementImageContentRequest,
): Promise<GenericPostResponse<RasterDTO>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'loadImagePreview'), request, true);

export const previewAnnouncementAPI = (
  request: AnnouncementItemContentRequest,
): Promise<GenericPostResponse<RealTimeAnnouncementPreviewDTO>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'preview'), request, true);

export const generateMp3AnnouncementAPI = (
  request: AnnouncementGenerateMp3Request,
): Promise<GenericPostResponse<AnnouncementAudioResponse>> =>
  apiGenericPost(getApiUrl(BASE_URL, 'generateMp3'), request, true);
